import { render, staticRenderFns } from "./RichTextVitals.vue?vue&type=template&id=73597b9b&scoped=true"
import script from "./RichTextVitals.vue?vue&type=script&lang=js"
export * from "./RichTextVitals.vue?vue&type=script&lang=js"
import style0 from "./RichTextVitals.vue?vue&type=style&index=0&id=73597b9b&prod&lang=scss"
import style1 from "./RichTextVitals.vue?vue&type=style&index=1&id=73597b9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73597b9b",
  null
  
)

export default component.exports